(function(){
  const storySection = $(".js-storySection");
  
  let sectionsData = [];
  let pos = 0;

  for (let i = 0, len = storySection.length; i < len; i=(i+1)|0) {
    sectionsData[i] = getSectionData(storySection.eq(i));
  }

  function showText(){
    const standardPosition = pos + 25;
    for (let i = 0, len = storySection.length; i < len; i=(i+1)|0) {
      const crtSectionData = sectionsData[i];

      if ( standardPosition <= crtSectionData.start || standardPosition >= crtSectionData.end ) {
        continue;
      }

      const step = (crtSectionData.height) / crtSectionData.imgLength;
      const posInSection = standardPosition - crtSectionData.start;
      const slideNum = posInSection / step;

//      console.log(slideNum)

      if (slideNum < 0.7) {
        return;
      }
      
      storySection.eq(i).addClass('is-showDescription');

    }
  }

  function getSectionData(element){
    const $elem = $(element);
    let crtSectionData = {};
    crtSectionData.start = $elem.offset().top;
    crtSectionData.height = $elem.innerHeight();
    crtSectionData.end = crtSectionData.start + crtSectionData.height;
    crtSectionData.imgLength = $elem.find(".p-storySection__img").length;
    return crtSectionData;
  }

  function checkPos(){
    pos = $(window).scrollTop();
    return pos;
  }

  $(window).on("scroll", function() {
    checkPos();
    showText();
  });

  $(window).on('load resize', function() {
    pos = checkPos();
    for (let i = 0, len = storySection.length; i < len; i=(i+1)|0) {
      const data = getSectionData(storySection.eq(i));
      sectionsData[i] = data;
    }
//    console.log(sectionsData);
  });
})();
